import {
  useGetListItems,
  useGetItemById,
  useMutateItem,
  useGetItem,
} from '../../hooks/entityMethodsHook'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import Api from '../../lib/api'

interface DeleteProjectPhotoParams {
  projectId: string
  photoId: string
}

export const useGetProjects = (
  queryKey: string,
  value: any,
  queryOptions: any
) => {
  const uri = 'projects/search'
  // return useGetPaginatedListItems(queryKey, uri, queryOptions)
  return useGetListItems(queryKey, uri)
}

export const useGetProjectsAll = (
  queryKey: string,
  enabled?: boolean | undefined,
  query?: string | undefined
) => {
  const uri = 'projects/search' + (query ?? '')
  return useGetListItems(queryKey, uri, enabled)
}

export const useFilterProjects = (
  queryKey: string,
  query?: string | undefined
) => {
  const uri = 'projects' + (query ?? '')
  return useGetListItems(queryKey, uri, true)
}

export const useProjectsCount = (queryKey: string) => {
  const uri = 'projects/count'
  return useGetListItems(queryKey, uri, true)
}

// export const useGetProjectCostCodes = (key: string, projectId: string | undefined) => {
//   return useGetCostCodes(key, projectId)
// }

export const useGetProject = (key: string, projectId: any | undefined) => {
  const uri = `projects/${projectId}?populate=superintendents`
  return useGetItemById(key, uri, projectId)
}

export const useMutateCreateProject = (key: string) => {
  const uri = `projects`
  return useMutateItem(key, uri)
}

// Updated to use new route.
export const useGetLatestTimeSheetByWorker = (
  key: string,
  workerId: any | undefined
) => {
  const uri = `timecards/${workerId}/timecard`
  return useGetItemById(key, uri, workerId)
}

export const useGetDailyReportFormData = (
  key: string,
  projectId: any | undefined
) => {
  const uri = `projects/${projectId}/daily-report-data`
  return useGetItem(key, uri, projectId)
}

export const useGetProjectsBySuper = (
  queryKey: string,
  superId: any,
  enabled?: boolean | undefined
) => {
  const uri = `dashboard/projects/super/${superId}`
  return useGetListItems(queryKey, uri, enabled)
}

export const useGetTimeMaterialFormData = (
  key: string,
  projectId: any | undefined
) => {
  const uri = `projects/${projectId}/time-material-data`
  return useGetItem(key, uri, projectId)
}
export const useDeleteProjectPhoto = (key: any) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  const mutation = useMutation<void, unknown, DeleteProjectPhotoParams>(
    async ({ projectId, photoId }) => {
      const token = await getAccessTokenSilently()
      return await Api.delete(
        `v1/projects/${projectId}/photos/${photoId}`,
        token
      )
    },
    {
      onSuccess: () => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({
            queryKey: ['projectphotos'],
          }),
        ])
      },
    }
  )

  return mutation
}

export const useUpdateProjectPhoto = (key: any) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  const mutation = useMutation<void, unknown, any>(
    async ({ projectId, photoId, formData }: any) => {
      const token = await getAccessTokenSilently()
      return await Api.patch(
        `v1/projects/${projectId}/photos/${photoId}`,
        formData,
        token
      )
    },
    {
      onSuccess: () => {
        Promise.all([
          queryClient.invalidateQueries({ queryKey: [key] }),
          queryClient.invalidateQueries({
            queryKey: ['projectphotos'],
          }),
        ])
      },
    }
  )

  return mutation
}

export const useMutateDeleteProject = (key: string) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  const mutation = useMutation(
    async (ids: any) => {
      const token = await getAccessTokenSilently()
      const response = await Api.delete(`v1/projects/${ids}`, token)
      return response
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [key] })
      },
      onError: (error: any) => {
        console.error('Error deleting project:', error)
      },
    }
  )

  return mutation
}
